<div class="modal-header">
    <div class="clearfix">Glossario</div>
</div>
<div class="modal-body">
    <div class="input-group text-center clearfix">
        <div class="float-left btn-block">
            <button
                nbButton
                type="button"
                class="btn text-center btn-sm m-2 btn_glossario"
                [ngClass]="{'active' : selected_letter == l}"
                *ngFor="let l of alphabets"
                (click)="glossarioFaqs(l)"
            >{{l}}</button>
        </div>
    </div>
    <faq
        [faqs]="filtered_faqs"
        [all_faqs]="faqs"
    ></faq>
</div>
